@use "@fukuri-admins/ui/layout" as *;

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
  padding-bottom: 100px; // footerの高さ分のスペースを確保
}

.breadcrumbWrapper {
  border-bottom: 1px solid border("Tertiary");
  padding: spacing("16") spacing("24");
}

.contentWrapper {
  padding: spacing("24");
}

.title {
  @include typography("Jp/20_W6");
  color: text("High");
}

.content {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
  max-width: 600px;
  margin-top: spacing("24");
}

.field {
  display: flex;
  flex-direction: column;
  gap: spacing("8");
}

.label {
  @include typography("Jp/14_W3");
  color: text("High");
}

.value {
  @include typography("Jp/14_W3");
  color: text("High");
}

.actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: spacing("12");
  justify-content: center;
  padding: spacing("24");
  border-top: 1px solid border("Tertiary");
  background-color: background("Primary");
  z-index: 10;
}
